var map = {
	"./decidim/avatar-multiuser.png": "../decidim-core/app/packs/images/decidim/avatar-multiuser.png",
	"./decidim/brands/facebook.svg": "../decidim-core/app/packs/images/decidim/brands/facebook.svg",
	"./decidim/brands/google.svg": "../decidim-core/app/packs/images/decidim/brands/google.svg",
	"./decidim/brands/twitter-x.svg": "../decidim-core/app/packs/images/decidim/brands/twitter-x.svg",
	"./decidim/cc-badge.png": "../decidim-core/app/packs/images/decidim/cc-badge.png",
	"./decidim/decidim-logo.svg": "../decidim-core/app/packs/images/decidim/decidim-logo.svg",
	"./decidim/default-avatar.svg": "../decidim-core/app/packs/images/decidim/default-avatar.svg",
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": "../decidim-core/app/packs/images/decidim/gamification/badges/decidim_gamification_badges_followers.svg",
	"./decidim/icons.svg": "../decidim-core/app/packs/images/decidim/icons.svg",
	"./decidim/pattern.png": "../decidim-core/app/packs/images/decidim/pattern.png",
	"./decidim/placeholder-card-g.svg": "../decidim-core/app/packs/images/decidim/placeholder-card-g.svg",
	"./decidim/placeholder-card-l.svg": "../decidim-core/app/packs/images/decidim/placeholder-card-l.svg",
	"./decidim/placeholder.jpg": "../decidim-core/app/packs/images/decidim/placeholder.jpg",
	"./decidim/remixicon.symbol.svg": "../decidim-core/app/packs/images/decidim/remixicon.symbol.svg",
	"./decidim/vendor/social-share-button/douban.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/douban.svg",
	"./decidim/vendor/social-share-button/email.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/email.svg",
	"./decidim/vendor/social-share-button/facebook.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/facebook.svg",
	"./decidim/vendor/social-share-button/google_bookmark.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/google_bookmark.svg",
	"./decidim/vendor/social-share-button/hacker_news.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/hacker_news.svg",
	"./decidim/vendor/social-share-button/linkedin.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/linkedin.svg",
	"./decidim/vendor/social-share-button/odnoklassniki.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/odnoklassniki.svg",
	"./decidim/vendor/social-share-button/pinterest.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/pinterest.svg",
	"./decidim/vendor/social-share-button/reddit.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/reddit.svg",
	"./decidim/vendor/social-share-button/telegram.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/telegram.svg",
	"./decidim/vendor/social-share-button/tumblr.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/tumblr.svg",
	"./decidim/vendor/social-share-button/twitter.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/twitter.svg",
	"./decidim/vendor/social-share-button/vkontakte.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/vkontakte.svg",
	"./decidim/vendor/social-share-button/wechat.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/wechat.svg",
	"./decidim/vendor/social-share-button/whatsapp.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/whatsapp.svg",
	"./decidim/vendor/social-share-button/x.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/x.svg",
	"./decidim/vendor/social-share-button/xing.svg": "../decidim-core/app/packs/images/decidim/vendor/social-share-button/xing.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../decidim-core/app/packs/images sync recursive ^\\.\\/.*$";